import { put, takeLeading } from 'redux-saga/effects';

import managePromotionApi from 'api/managePromotionApi';
import { apiErrorHandler, showSuccess } from 'utils';

import {
  GET_MARKETING_PROMOTION_LIST,
  GET_MARKETING_PROMOTION_LIST_SUCCESS,
  GET_MARKETING_PROMOTION_LIST_FAILED,
  GET_MARKETING_PROMOTION_DETAIL,
  GET_MARKETING_PROMOTION_DETAIL_SUCCESS,
  GET_MARKETING_PROMOTION_DETAIL_FAILED,
  CREATE_MARKETING_PROMOTION,
  CREATE_MARKETING_PROMOTION_SUCCESS,
  CREATE_MARKETING_PROMOTION_FAILED,
  UPDATE_MARKETING_PROMOTION,
  UPDATE_MARKETING_PROMOTION_SUCCESS,
  UPDATE_MARKETING_PROMOTION_FAILED,
  DELETE_MARKETING_PROMOTION,
  DELETE_MARKETING_PROMOTION_SUCCESS,
  DELETE_MARKETING_PROMOTION_FAILED,
} from './actionTypes';

function* getMarketingPromotionList({ payload }) {
  try {
    const response = yield managePromotionApi.getListMarketingPromotion(payload);

    yield put({
      type: GET_MARKETING_PROMOTION_LIST_SUCCESS,
      payload: response.payload || response,
    });
  } catch (error) {
    apiErrorHandler(error);
    yield put({
      type: GET_MARKETING_PROMOTION_LIST_FAILED,
    });
  }
}

function* getMarketingPromotionDetail({ payload }) {
  try {
    const response = yield managePromotionApi.getDetailMarketingPromotion(payload.id);

    yield put({
      type: GET_MARKETING_PROMOTION_DETAIL_SUCCESS,
      payload: response.payload || response,
    });
  } catch (error) {
    apiErrorHandler(error);
    yield put({
      type: GET_MARKETING_PROMOTION_DETAIL_FAILED,
    });
  }
}

function* createMarketingPromotion({ payload }) {
  const { values, callback } = payload;
  try {
    const response = yield managePromotionApi.createMarketingPromotion(values);

    yield put({
      type: CREATE_MARKETING_PROMOTION_SUCCESS,
      payload: response.payload || response,
    });
    showSuccess('Tạo ưu đãi tiếp thị thành công');
    if (callback) callback(response?.payload || response);
  } catch (error) {
    apiErrorHandler(error);
    yield put({
      type: CREATE_MARKETING_PROMOTION_FAILED,
    });
  }
}

function* updateMarketingPromotion({ payload }) {
  const { id, values, callback } = payload;
  try {
    const response = yield managePromotionApi.updateMarketingPromotion(id, values);

    yield put({
      type: UPDATE_MARKETING_PROMOTION_SUCCESS,
      payload: response.payload || response,
    });
    showSuccess('Cập nhật ưu đãi tiếp thị thành công');
    if (callback) callback(response?.payload || response);
  } catch (error) {
    apiErrorHandler(error);
    yield put({
      type: UPDATE_MARKETING_PROMOTION_FAILED,
    });
  }
}

function* deleteMarketingPromotion({ payload }) {
  const { id, callback } = payload;
  try {
    const response = yield managePromotionApi.delete(id);

    yield put({
      type: DELETE_MARKETING_PROMOTION_SUCCESS,
      payload: response.payload || response,
    });
    showSuccess('Xóa ưu đãi tiếp thị thành công');
    if (callback) callback();
  } catch (error) {
    apiErrorHandler(error);
    yield put({
      type: DELETE_MARKETING_PROMOTION_FAILED,
    });
  }
}

export default function* managerPromotionSaga() {
  yield takeLeading(GET_MARKETING_PROMOTION_LIST, getMarketingPromotionList);
  yield takeLeading(GET_MARKETING_PROMOTION_DETAIL, getMarketingPromotionDetail);
  yield takeLeading(CREATE_MARKETING_PROMOTION, createMarketingPromotion);
  yield takeLeading(UPDATE_MARKETING_PROMOTION, updateMarketingPromotion);
  yield takeLeading(DELETE_MARKETING_PROMOTION, deleteMarketingPromotion);
}
